import React from "react";
import { useNavigate } from "react-router-dom";

import { Login as LoginComponent } from "../../components/login";

const Login = ({ errors, isLoggedIn, login, loginMethods, preloaders, user, keycloak }) => {
  const navigate = useNavigate();

  return (
    <LoginComponent
      errors={errors}
      isLoggedIn={isLoggedIn}
      navigate={navigate}
      login={login}
      loginMethods={loginMethods}
      preloaders={preloaders}
      user={user}
      keycloak={keycloak}
    />
  );
};

export default Login;
